import React from "react";
import { useQueryClient } from "@tanstack/react-query";
import { ConfirmModal } from "../../../../../../boxes/ConfirmModal/ConfirmModal";
import { uiNotification } from "../../../../../../services/UINotificationService";
import { QUERY_KEYS } from "../../../../../../consts/api";
import { useDeletePfiConfig } from "../../hooks/useDeletePfiConfig";

const DeactivateModal = ({ config, onClose }) => {
  const queryClient = useQueryClient();

  const { mutate: deleteConfig, isLoading: isDeleting } = useDeletePfiConfig();

  const handleDeactivate = () => {
    deleteConfig(config.pfiPracticeId, {
      onSuccess: (data) => {
        onClose();
        queryClient.setQueryData(
          [QUERY_KEYS.patientFi.getIntegration],
          () => data,
        );

        const successMessages = data?.data?.data?.messages;
        const errors = data?.data?.data?.errors;

        if (successMessages.length > 0) {
          successMessages.forEach((message) => {
            uiNotification.success(message);
          });
        }

        if (errors.length > 0) {
          errors.forEach((error) => {
            uiNotification.error(error);
          });
        }
      },
      onError: (error) => {
        uiNotification.error(
          error?.response?.data?.message || "Failed to deactivate config",
        );
      },
    });
  };

  return (
    <ConfirmModal
      isOpen
      onClose={onClose}
      title="Confirmation Required"
      onCancel={onClose}
      onConfirm={handleDeactivate}
      isConfirming={isDeleting}
    >
      Are you sure you want to deactivate <b>{config.name}</b>?
    </ConfirmModal>
  );
};

export default DeactivateModal;
